import {Component, Input, OnChanges, OnInit, SimpleChanges} from '@angular/core';
import {MyProjectStatusBarTranslateEnum} from '../../../../enums/my-project-status-bar-translate.enum';
import {EnumUtils} from '../../../../utils/enum.utils';
import {ProjectStatusEnum} from '../../../../enums/project-status.enum';

@Component({
  selector: 'app-project-status-progress-bar',
  templateUrl: './project-status-progress-bar.component.html',
  styleUrls: ['./project-status-progress-bar.component.scss']
})
export class ProjectStatusProgressBarComponent  implements OnInit, OnChanges {


    @Input() status: ProjectStatusEnum;
    @Input() date: Date;

    public progressBarSteps: boolean[] = new Array(5);
    public progress = 0;
    public activeBarItemColor = 'rgba( 16, 211, 102,.5)';

    public label: string;

    constructor() {
    }

    ngOnInit() {
    }

    ngOnChanges(changes: SimpleChanges): void {


        if (this.status !== undefined) {

            this.label = MyProjectStatusBarTranslateEnum[ EnumUtils.getKeyByValue(ProjectStatusEnum, this.status)];
            switch ( this.status) {
                case ProjectStatusEnum.DRAFT:
                    this.activeBarItemColor = 'rgba( 0,0,0,.18)';
                    this.progress = 1;
                    break;
                case ProjectStatusEnum.REQUEST:
                    this.progress = 2;
                    break;
                case ProjectStatusEnum.IN_PROCESS:
                    this.progress = 3;
                    break;
                case ProjectStatusEnum.QUOTE_SENT:
                    this.progress = 4;
                    break;
                case ProjectStatusEnum.QUOTE_SENT_MANUALLY:
                    this.progress = 4;
                    break;
                case ProjectStatusEnum.PROJECT_WON:
                    this.activeBarItemColor =  'rgba(16, 211, 102,1)';
                    this.progress = 5;
                    break;
                case ProjectStatusEnum.REJECTED:
                    this.activeBarItemColor = 'rgba(242, 77, 77, 0.5)';
                    this.progress = 5;
                    break;
                case ProjectStatusEnum.PROJECT_LOST:
                    this.activeBarItemColor = 'rgba(242, 77, 77, 1)';
                    this.progress = 5;
                    break;
                case ProjectStatusEnum.DELETED:
                    this.activeBarItemColor = 'rgba( 0,0,0,.18)';
                    this.progress = 0;
                    break;
                default:
                    console.warn('status was not recognized:', this.status );
            }
        }
    }
}
